import {
  CardTitleAndSubtitleContainer,
  WeeklyActivityTitleContainer,
} from 'components/DashboardCards/cardStyles';
import TaskSummaryCard from 'components/DashboardCards/taskSummaryCard';
import { t } from 'i18next';
import moment from 'moment';
import { useEffect } from 'react';
import { DashboardCardTitle } from 'styledComponents/dashboard';

import TaskProgressOverview from '../../components/DashboardCards/TaskProgressOverview';
import ComponentCircleLoader from '../../components/Loaders/ComponentCircleLoader';
import { ColoredText, PageTitle } from '../../styledComponents/common';
import {
  BillingTooltip,
  BillingTooltipText,
} from '../../styledComponents/createProject';
import TaskProgressBarChart from './TaskProgressBarChart';
import TicketCountByTypeChart from './TicketCountByTypeChart';
import {
  DashboardCardContainer,
  DashboardCardsContainer,
  DashboardPageContent,
  DashboardPageHeader,
  DateRangeContainer,
  DateRangeTooltip,
  SmallCardContainer,
  TitleAndModeSelectorDiv,
} from './dashboardStyles';

const getTime = time => {
  let timeInSeconds = parseInt(time);
  let minutes = Math.floor(timeInSeconds / 60) % 60;
  let hours = Math.floor(timeInSeconds / 3600);

  return `${hours}h ${minutes}m`;
};

const DateRangeSection = ({ startDate, endDate, year }) => {
  return (
    <DateRangeContainer>
      <ColoredText type="blue" fontSize="12px">
        {startDate} - {endDate}, {year}
      </ColoredText>
      <DateRangeTooltip>
        ?
        <BillingTooltip top="32px" left="-230px">
          <BillingTooltipText>
            This is the Organization’s weekly data that starts every Monday and
            ends next Sunday.
          </BillingTooltipText>
        </BillingTooltip>
      </DateRangeTooltip>
    </DateRangeContainer>
  );
};
// Please note that today's data is not included here - this text has been removed

const Dashboard = props => {
  // const dashboardData = {
  //   offline_employees: 1220,
  //   online_employees: 1350,
  //   task_progress_overview: [
  //     {
  //       office: 'Albait',
  //       complete: 120,
  //       partially_complete: 45,
  //       missed: 7,
  //     },
  //     {
  //       office: 'Albait Guest',
  //       complete: 34,
  //       partially_complete: 2,
  //       missed: 0,
  //     },
  //   ],

  //   performance_comparison: {
  //     today: {
  //       complete: 34,
  //       partially_complete: 1,
  //       missed: 1,
  //       late: 8,
  //     },
  //     yesterday: {
  //       complete: 27,
  //       partially_complete: 10,
  //       missed: 4,
  //       late: 2,
  //     },
  //   },
  //   late_count_comparison: {
  //     today: 1396,
  //     yesterday: 1396,
  //   },
  // };
  const {
    location,
    history,
    getDashboardStatus,
    getDashboardTaskProgress,
    getDashboardPerformance,
    getDashboardLateCount,
    getDashboardTopLowPerformers,
    getDashboardUserAnalytics,
    getDashboardTimeMetrics,
    getDashboardTicketCountByType,
    // dashboardData,
    employeeStatusIsloading,
    employee_status,
    taskProgressIsLoading,
    task_progress_overview,
    performanceComparisonIsLoading,
    performance_comparison,
    lateCountIsloading,
    late_count_comparison,
    topLowPerformersIsLoading,
    top_low_performers,
    task_Summary,
    taskSummaryIsLoading,
    getDashboardTaskSummary,
    timeMetricsIsLoading,
    time_metrics,
    ticketCountByTypeIsLoading,
    ticket_count_by_type,
    responseTimeMetricsIsLoading,
    response_time_metrics,
    getDashboardTicketResponseTimeMetrics,
  } = props;
  // Default time metrics object to prevent errors if the API hasn't loaded yet
  const timeMetrics = time_metrics
    ? {
        average_ticket_duration: time_metrics.metrics
          ? time_metrics.metrics.average_time_formatted
          : '-',
        maximum_ticket_duration: time_metrics.metrics
          ? time_metrics.metrics.max_time_formatted
          : '-',
        minimum_ticket_duration: time_metrics.metrics
          ? time_metrics.metrics.min_time_formatted
          : '-',
      }
    : {
        average_ticket_duration: '-',
        maximum_ticket_duration: '-',
        minimum_ticket_duration: '-',
      };

  const responseTimeMetrics = response_time_metrics
    ? {
        average_response_time: response_time_metrics.metrics
          ? response_time_metrics.metrics.average_response_time_formatted
          : '-',
        maximum_response_time: response_time_metrics.metrics
          ? response_time_metrics.metrics.max_response_time_formatted
          : '-',
        minimum_response_time: response_time_metrics.metrics
          ? response_time_metrics.metrics.min_response_time_formatted
          : '-',
      }
    : {
        average_response_time: '-',
        maximum_response_time: '-',
        minimum_response_time: '-',
      };

  const userRole = localStorage.getItem('user_role');
  useEffect(() => {
    if (userRole === 'admin' || userRole === 'gm' || userRole === 'agm') {
      getDashboardStatus();
      getDashboardPerformance();
    }
    getDashboardTaskProgress();
    getDashboardTaskSummary();
    getDashboardTimeMetrics();
    getDashboardTicketCountByType();
    getDashboardTicketResponseTimeMetrics();
  }, []);

  return (
    <div className="content">
      <DashboardPageHeader>
        <TitleAndModeSelectorDiv>
          <PageTitle style={{ marginBottom: '0' }}>{t('Dashboard')}</PageTitle>
        </TitleAndModeSelectorDiv>
      </DashboardPageHeader>
      <DashboardPageContent marginTop="20px">
        <DashboardCardsContainer
          columns="1fr"
          laptopColumns="1fr"
          tabletColumns="1fr"
          marginTop="20px"
          background="white"
          padding="20px"
          columnGap="0px"
        >
          <WeeklyActivityTitleContainer margin="0 0 10px 0" padding="0">
            <CardTitleAndSubtitleContainer>
              <DashboardCardTitle>
                {t('overall_information')}
              </DashboardCardTitle>
            </CardTitleAndSubtitleContainer>
          </WeeklyActivityTitleContainer>
          <DashboardCardContainer
            columns="1fr 1fr 1fr 1fr"
            laptopColumns="1fr 1fr 1fr"
            tabletColumns="1fr 1fr"
            mobileColumns="1fr"
          >
            {taskSummaryIsLoading || employeeStatusIsloading ? (
              <>
                <SmallCardContainer>
                  <ComponentCircleLoader padding="5vh" />
                </SmallCardContainer>
                <SmallCardContainer>
                  <ComponentCircleLoader padding="5vh" />
                </SmallCardContainer>
                <SmallCardContainer>
                  <ComponentCircleLoader padding="5vh" />
                </SmallCardContainer>
                <SmallCardContainer>
                  <ComponentCircleLoader padding="5vh" />
                </SmallCardContainer>
              </>
            ) : (
              <>
                {task_Summary && (
                  <>
                    <TaskSummaryCard
                      history={history}
                      title={'all_tickets'}
                      value={task_Summary.total}
                    />
                    <TaskSummaryCard
                      history={history}
                      title={'missed'}
                      value={task_Summary.missed}
                    />
                    <TaskSummaryCard
                      history={history}
                      title={'assigned'}
                      value={task_Summary.assigned}
                    />
                    <TaskSummaryCard
                      history={history}
                      title={'re_assigned'}
                      value={task_Summary.re_assigned}
                    />
                    <TaskSummaryCard
                      history={history}
                      title={'in_progress'}
                      value={task_Summary.in_progress}
                    />
                    <TaskSummaryCard
                      history={history}
                      title={'cancelled'}
                      value={task_Summary.cancelled}
                    />
                    <TaskSummaryCard
                      history={history}
                      title={'closed'}
                      value={task_Summary.closed}
                    />
                    <TaskSummaryCard
                      history={history}
                      title={'completed'}
                      value={task_Summary.completed}
                    />
                    {/* {userRole !== 'monazim' && ( */}
                    <>
                      <TaskSummaryCard
                        history={history}
                        title={'pending_approval'}
                        value={task_Summary.pending_approval}
                      />
                      <TaskSummaryCard
                        history={history}
                        title={'approved'}
                        value={task_Summary.approved}
                      />
                      <TaskSummaryCard
                        history={history}
                        title={'rejected'}
                        value={task_Summary.rejected}
                      />
                    </>
                    {/* )} */}
                  </>
                )}
              </>
            )}
          </DashboardCardContainer>
        </DashboardCardsContainer>{' '}
        {['admin'].includes(userRole) && (
          <DashboardCardsContainer
            columns="1fr"
            laptopColumns="1fr"
            tabletColumns="1fr"
            marginTop="20px"
            background="white"
            padding="20px"
            columnGap="0px"
          >
            <DashboardCardContainer
              columns="1fr 1fr 1fr"
              laptopColumns="1fr 1fr 1fr"
              tabletColumns="1fr 1fr"
              mobileColumns="1fr"
            >
              {timeMetricsIsLoading ? (
                <>
                  <SmallCardContainer>
                    <ComponentCircleLoader padding="5vh" />
                  </SmallCardContainer>
                  <SmallCardContainer>
                    <ComponentCircleLoader padding="5vh" />
                  </SmallCardContainer>
                  <SmallCardContainer>
                    <ComponentCircleLoader padding="5vh" />
                  </SmallCardContainer>
                </>
              ) : (
                <>
                  {' '}
                  <TaskSummaryCard
                    history={history}
                    title={'average_ticket_duration'}
                    value={timeMetrics.average_ticket_duration}
                  />
                  <TaskSummaryCard
                    history={history}
                    title={'maximum_ticket_duration'}
                    value={timeMetrics.maximum_ticket_duration}
                  />{' '}
                  <TaskSummaryCard
                    history={history}
                    title={'minimum_ticket_duration'}
                    value={timeMetrics.minimum_ticket_duration}
                  />
                </>
              )}
            </DashboardCardContainer>
          </DashboardCardsContainer>
        )}
        {['admin'].includes(userRole) && (
          <DashboardCardsContainer
            columns="1fr"
            laptopColumns="1fr"
            tabletColumns="1fr"
            marginTop="20px"
            background="white"
            padding="20px"
            columnGap="0px"
          >
            <DashboardCardContainer
              columns="1fr 1fr 1fr"
              laptopColumns="1fr 1fr 1fr"
              tabletColumns="1fr 1fr"
              mobileColumns="1fr"
            >
              {responseTimeMetricsIsLoading ? (
                <>
                  <SmallCardContainer>
                    <ComponentCircleLoader padding="5vh" />
                  </SmallCardContainer>
                  <SmallCardContainer>
                    <ComponentCircleLoader padding="5vh" />
                  </SmallCardContainer>
                  <SmallCardContainer>
                    <ComponentCircleLoader padding="5vh" />
                  </SmallCardContainer>
                </>
              ) : (
                <>
                  <TaskSummaryCard
                    history={history}
                    title={'average_response_time'}
                    value={responseTimeMetrics.average_response_time}
                  />
                  <TaskSummaryCard
                    history={history}
                    title={'maximum_response_time'}
                    value={responseTimeMetrics.maximum_response_time}
                  />
                  <TaskSummaryCard
                    history={history}
                    title={'minimum_response_time'}
                    value={responseTimeMetrics.minimum_response_time}
                  />
                </>
              )}
            </DashboardCardContainer>
          </DashboardCardsContainer>
        )}
        {/* {['admin', 'gm', 'agm', 'monazim', 'sub-monazim'].includes(userRole) && ( */}
        <DashboardCardContainer
          columns="1fr"
          laptopColumns="1fr"
          tabletColumns="1fr"
          marginTop="20px"
        >
          {/* <EmployeeActivityCard
            employee_status={employee_status}
            isLoading={employeeStatusIsloading}
          /> */}
          <TaskProgressOverview
            task_progress_overview={task_progress_overview}
            isLoading={taskProgressIsLoading}
            history={history}
          />
        </DashboardCardContainer>
        {/* )} */}
        {/* Task Progress Bar Chart */}{' '}
        {/* {['admin', 'gm', 'agm', 'monazim', 'sub-monazim'].includes(userRole) && ( */}
        <DashboardCardContainer
          columns="1fr"
          laptopColumns="1fr"
          tabletColumns="1fr"
          marginTop="20px"
        >
          <TaskProgressBarChart
            data={task_progress_overview}
            isLoading={taskProgressIsLoading}
          />
        </DashboardCardContainer>
        {/* )} */}
        {/* Ticket Count By Type Chart */}
        <DashboardCardsContainer
          columns="1fr"
          laptopColumns="1fr"
          tabletColumns="1fr"
          marginTop="20px"
          background="white"
          padding="20px"
        >
          <TicketCountByTypeChart
            data={ticket_count_by_type}
            isLoading={ticketCountByTypeIsLoading}
          />
        </DashboardCardsContainer>
      </DashboardPageContent>
    </div>
  );
};

export default Dashboard;
